<template>
  <SvoiInput
    v-model="computedValue"
    :label="label"
    icon="search/search-normal"
    :size="size"
    @on-click-icon="emit('search')"
    @keyup.enter="emit('search')"
  />
</template>

<script setup lang="ts">
  import { SvoiInput } from '@svoi-ui/components/input'

  interface Props {
    modelValue?: string
    label?: string
    size?: 'm' | 'l'
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: '',
    label: 'Найти',
    size: 'm',
  })

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
    (e: 'search'): void
  }>()

  const computedValue = computed({
    get: () => props.modelValue,
    set: val => emit('update:modelValue', val),
  })
</script>
